module.exports = __webpack_public_path__ + "static/flags/GJ-03c56d5e8393db3adeef03b850bb6e73.gif";